var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-table',{attrs:{"fields":_vm.fields,"items":_vm.stats}}),(_vm.stats == undefined)?_c('h2',{staticClass:"Nodata"},[_vm._v("No Data")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }